import { type CourseOverviewLearningUnitFragment } from '@lingoda/monolith-graphql';
import { CardHeader, Typography } from '@lingoda/ui';
import { getChapterName } from '@lingoda/learning-units';
import LingodaIcon from './LingodaIcon';

interface Props {
    learningUnit: CourseOverviewLearningUnitFragment;
}

export const LearningUnitHeader = ({ learningUnit }: Props) => {
    const chapterName = getChapterName(learningUnit);

    return (
        <CardHeader
            avatar={<LingodaIcon icon={learningUnit.icon || ''} color={learningUnit.color} />}
            subheader={<Typography htmlColor="text.secondary">{chapterName}</Typography>}
            sx={{ '.MuiCardHeader-content': { display: 'flex', flexDirection: 'column-reverse' } }}
            title={<Typography variant="body1">{learningUnit.name}</Typography>}
        />
    );
};
